<template>
  <div>
    <div class="font-weight-medium text-h6 mb-3">
      {{ $i18n.t("working_time.title") }}
    </div>
    <v-card class="rounded-md mb-4">
      <div class="d-flex align-center justify-start px-4 py-3 flex-wrap">
        <v-btn
          depressed
          @click="refreshItems()"
          :loading="loading.refresh"
          class="mr-2"
        >
          <v-icon left>mdi-refresh</v-icon>
          {{ $i18n.t("btn.refresh") }}
        </v-btn>
        <div class="ml-auto">
          <v-btn color="primary" @click="addWorkingTime()">
            <v-icon left>mdi-plus-circle-outline</v-icon>
            <span>{{ $i18n.t("btn.add") }}</span>
          </v-btn>
        </div>
      </div>
    </v-card>
    <v-card>
      <v-data-table
        :loading="loading.list"
        :headers="headers"
        :items="items"
        :options.sync="pagination"
        :footer-props="footerProps"
        :items-per-page="itemPerPage"
        sort-by="id"
        sort-desc
      >
        <template v-slot:body="{ items }" v-if="!_.isEmpty(items)">
          <tbody>
            <template v-for="item in items">
              <v-hover :key="item.id" v-slot="{ hover }">
                <tr>
                  <td style="min-width: 160px">
                    <span>
                      {{
                        $moment(item.createdAt).format("YYYY-MM-DD HH:mm:ss")
                      }}
                    </span>
                  </td>
                  <td>{{ item.service.name }}</td>
                  <td>{{ item.data.title }}</td>
                  <td style="min-width: 120px">
                    <template
                      v-if="$permission.$can('working-time.update', ['user', 'service'])"
                    >
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-show="hover || $vuetify.breakpoint.mdAndDown"
                            x-small
                            icon
                            v-bind="attrs"
                            v-on="on"
                            @click="editWorkingTime(item)"
                          >
                            <v-icon color="primary">mdi-pencil-outline</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t("working_time.btn.edit") }}</span>
                      </v-tooltip>
                    </template>
                    <template
                      v-if="$permission.$can('working-time.delete', ['user', 'service'])"
                    >
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-show="hover || $vuetify.breakpoint.mdAndDown"
                            x-small
                            icon
                            v-bind="attrs"
                            v-on="on"
                            @click="deleteWorkingTime(item)"
                            class="ml-2"
                          >
                            <v-icon color="primary">mdi-delete-outline</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t("working_time.btn.delete") }}</span>
                      </v-tooltip>
                    </template>
                  </td>
                </tr>
              </v-hover>
            </template>
          </tbody>
        </template>
      </v-data-table>
    </v-card>
    <working-time-form
      :services="services"
      :dialog="dialog.form"
      :workingTime="workingTime"
      @refresh="refreshItems"
    ></working-time-form>
    <confirm-delete-working-time
      :dialog="dialog.delete"
      @confirm="confirmDeleteWorkingTime"
    ></confirm-delete-working-time>
  </div>
</template>

<script>
import ConfirmDeleteWorkingTime from "./../commons/confirm.vue";
import WorkingTimeForm from "./form";
import ListMixin from "./../../mixins/list";
import { mapActions } from "vuex";

export default {
  mixins: [ListMixin],
  created() {
    this.setServices();
  },
  data: () => ({
    path: "working-time.list",
    dialog: {
      form: {
        display: false,
        title: null,
      },
      delete: {
        display: false,
        message: null,
      },
    },
    services: [],
    workingTime: {},
  }),
  methods: {
    async setServices() {
      try {
        this.services = (
          await this.request({ url: "services.list?limit=50" })
        ).data.data;
      } catch (error) {
        // empty
      }
    },
    setHeaders() {
      this.headers = [
        {
          text: this.$i18n.t("common.fields.created.title"),
          align: "start",
          sortable: true,
          value: "createdAt",
          width: 160,
        },
        {
          text: this.$i18n.t("common.fields.serviceId.title"),
          align: "start",
          sortable: false,
          value: "service.name",
          width: 160,
        },
        {
          text: this.$i18n.t("common.fields.title.title"),
          align: "start",
          sortable: false,
          value: "data.title",
        },
        {
          text: "",
          align: "start",
          sortable: false,
          value: null,
          width: 120,
        },
      ];
    },
    addWorkingTime() {
      this.workingTime = {};
      this.dialog.form = {
        display: true,
        title: this.$t("working_time.add.title"),
      };
    },
    editWorkingTime(item) {
      this.workingTime = item;
      this.dialog.form = {
        display: true,
        title: this.$t("working_time.edit.title"),
      };
    },
    deleteWorkingTime(item) {
      this.workingTime = item;
      this.dialog.delete.message = this.$t("working_time.delete.confirm");
      this.dialog.delete.display = true;
    },
    async confirmDeleteWorkingTime() {
      if (!this.workingTime.id) return;

      try {
        await this.request({
          url: `working-time.delete`,
          method: "POST",
          data: {
            workingTimeId: this.workingTime.id,
          },
          messages: {
            204: this.$t("working_time.delete.success"),
            403: true,
            422: this.$t("error_occured"),
            500: true,
          },
        });
        this.refreshItems();
      } catch (error) {
        // empty
      }
    },
    ...mapActions({ request: "request", notify: "notification/notify" }),
  },
  components: {
    WorkingTimeForm,
    ConfirmDeleteWorkingTime,
  },
};
</script>